import React, { useContext } from 'react';
import {
  Route, Switch,
} from 'react-router-dom';

import ConfigContext from '../../utils/ConfigContext/ConfigContext';

import PibPage from '../PibPage/PibPage';
import MapPage from '../MapPage/MapPage';
import MapTilesPage from '../MapTilesPage/MapTilesPage';
import FloorPlanPrintPage from '../FloorPlanPrintPage/FloorPlanPrintPage';

const NoChromeComponents = () => {
  const {
    config,
    mapConfig,
    settings,
  } = useContext( ConfigContext );

  const { platform } = settings;
  const { secondaryColor } = config;

  return (

    <Switch>

      {/* These components behave as pages */}
      <Route
        path="/:communitySlug/:sanitizedTitle/:drupalNid"
        exact
        component={PibPage}
      />

      <Route
        path="/:communitySlug/:drupalBundleType/:sanitizedTitle/:drupalNid"
        exact
        component={FloorPlanPrintPage}
      />

      {/* These components are full screen */}
      <Route
        path="/map-tiles"
        exact
        component={MapTilesPage}
      />

      <Route
        path="/map-embed"
        exact
        render={() => platform === 'siteSee' && (
          <MapPage
            mapData={mapConfig}
            secondaryColor={secondaryColor}
            isSiteSee
          />
        )}
      />

    </Switch>
  );
};

export default NoChromeComponents;
